import { render, staticRenderFns } from "./ProjectBoard.vue?vue&type=template&id=b6a7c370&scoped=true"
import script from "./ProjectBoard.vue?vue&type=script&lang=js"
export * from "./ProjectBoard.vue?vue&type=script&lang=js"
import style0 from "./ProjectBoard.vue?vue&type=style&index=0&id=b6a7c370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a7c370",
  null
  
)

export default component.exports